import $ from 'jquery';
import 'masonry-layout/dist/masonry.pkgd';

export const init = () => {

	var $grid = $('.grid--masonry');

	$grid
		.masonry({
			itemSelector: '.grid__cell',
		});
};
